var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ci-attachment"},[_c('RdxIcon',{class:_vm.classes}),_c('a',{staticClass:"ci-attachment__label",attrs:{"href":_vm.href,"target":"blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }